const IMG_EXT_RX = /\.(png|jpe?g|gif|webp|bmp|svg|avif)(?:$|[?#])/i;
const PDF_EXT_RX = /\.pdf(?:$|[?#])/i;

const toTrimmedString = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  return text || "";
};

const getFirstString = (value = {}, keys = []) => {
  for (const key of keys) {
    const text = toTrimmedString(value?.[key]);
    if (text) return text;
  }
  return "";
};

export const getOriginalFileUrl = (value = {}) =>
  getFirstString(value, ["fileUrl", "filePath", "proofFilePath", "FileUrl", "Image", "url", "link"]);

export const getStoredPreviewUrl = (value = {}) =>
  getFirstString(value, [
    "previewImageUrl",
    "previewUrl",
    "PreviewImageUrl",
    "thumbnailUrl",
    "ThumbnailUrl",
  ]);

export const hasReadyStoredPreview = (value = {}) => {
  const status = toTrimmedString(value?.previewStatus ?? value?.PreviewStatus).toLowerCase();
  const previewUrl = getStoredPreviewUrl(value);
  const originalUrl = getOriginalFileUrl(value);
  const previewKind = toTrimmedString(value?.previewKind ?? value?.PreviewKind).toLowerCase();
  const isFallback = previewKind === "fallback" || /-fallback\.png(?:$|[?#])/i.test(previewUrl);
  return status === "ready" && Boolean(previewUrl) && previewUrl !== originalUrl && !isFallback;
};

export const isBrowserImageUrl = (value = "") => IMG_EXT_RX.test(toTrimmedString(value));

export const isPdfUrl = (value = "") => PDF_EXT_RX.test(toTrimmedString(value));

export const getDisplayPreviewUrl = (value = {}) => {
  const previewUrl = getStoredPreviewUrl(value);
  if (previewUrl && hasReadyStoredPreview(value)) return previewUrl;

  const originalUrl = getOriginalFileUrl(value);
  if (originalUrl && isBrowserImageUrl(originalUrl) && !isPdfUrl(originalUrl)) return originalUrl;

  return "";
};

// Future renderers should use original URLs for download/open/history and preview URLs for display only.
